import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { I18NextNS } from 'src/models/Language.model';

import useConnectionCheck from 'src/hooks/useConnectionCheck';

import ConnectionIssueController from './ConnectionIssueController';

type NetworkErrorModalProps = {
  onClose: () => void;
};

export default function NetworkErrorModal({ onClose }: NetworkErrorModalProps) {
  const { setIsConnected } = useRemoteBoundStore();
  const checkConnection = useConnectionCheck();
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'connectionIssue.connectionRestoredModal',
  });

  const handleClose = () => {
    setIsConnected(true);
    onClose();
  };

  return (
    <ConnectionIssueController
      show
      onConnectionRestored={handleClose}
      checkConnection={checkConnection}
      secondaryButton={
        <Button
          variant="outline-gray-500"
          className="clear-exam-button"
          onClick={handleClose}
        >
          {t('close')}
        </Button>
      }
    />
  );
}
